import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import areSameGeo from './areSameGeo.js';
import SuggestionResult from './SuggestionResult.js';
import itemClasses from './Item.module.scss.js';
import ownClasses from './RecentSearches.module.scss.js';

const RecentSearches = ({ variant, getItemProps, highlightedIndex, searches, selectedItem, assetsBase, }) => {
    const [defaultOption, ...recentSearches] = searches;
    const highlightedIndices = searches.map((item, index) => highlightedIndex === index ||
        (selectedItem != null && areSameGeo(item.value, selectedItem.value)));
    const isSmall = variant === 'desktop';
    return (jsxs(Fragment, { children: [jsxs("li", { className: classNames(itemClasses.item, {
                    [itemClasses['size-small']]: isSmall,
                    [itemClasses.selected]: highlightedIndices[0],
                }), ...getItemProps({ item: defaultOption, index: 0 }), children: [jsx("img", { src: `${assetsBase}/static/icons/cactus/lens.svg`, width: "24", height: "24", alt: "" }), defaultOption.optionLabels] }, `${defaultOption.inputLabel}-default`), jsx("div", { className: ownClasses.title, children: jsx("p", { className: classNames('body-text', 'semibold', { small: isSmall }), children: "Ricerche recenti" }) }), recentSearches.map((item, index) => (jsxs("li", { className: classNames(itemClasses.item, {
                    [itemClasses['size-small']]: isSmall,
                    [itemClasses.selected]: highlightedIndices[index + 1],
                }), ...getItemProps({ item, index: index + 1 }), children: [jsx("img", { src: `${assetsBase}/static/icons/cactus/clock.svg`, width: "16", height: "16", alt: "", className: ownClasses['item-icon'] }), jsx(SuggestionResult, { geoOptionsLabels: item.optionLabels })] }, `${item.inputLabel}-${index + 1}`)))] }));
};

export { RecentSearches as default };
//# sourceMappingURL=RecentSearches.js.map
